import type { LabelAsDivProps, LabelAsLabelProps, LabelProps } from '@connected/ui/components/label';
import type { ReactNode } from 'react';

import { Label } from '@connected/ui/components/label';
import { cn } from '@connected/ui/lib/utils';

import type { PrimativeLabelType, PrimitiveValueType } from '../../lib/utils';

import { useFieldContext } from '../../hooks/use-form-context';
import { ClearField } from './clear-field';

export function LabelField(props: LabelAsDivProps & { asDiv: true }): ReactNode;
export function LabelField(props: LabelAsLabelProps & { asDiv?: false }): ReactNode;
export function LabelField(props: LabelProps): ReactNode {
    const { className, ...restProps } = props as LabelAsDivProps & LabelAsLabelProps;

    const field = useFieldContext<PrimitiveValueType>();

    return <Label htmlFor={field.name} className={cn('flex flex-col gap-2', className)} {...restProps} />;
}

LabelField.displayName = 'LabelField';

type LabelTitleProps = {
    label: PrimativeLabelType;
    isClearable?: boolean;
    required?: boolean;
    className?: string;
};

export function LabelTitle({ label, isClearable: cleable = false, required = false, className }: LabelTitleProps) {
    return (
        <div className={cn('flex items-center justify-between gap-2', className)}>
            <span className="text-sm font-medium">
                {label}
                {required && <span>*</span>}
            </span>
            {cleable && <ClearField />}
        </div>
    );
}

LabelField.Title = LabelTitle;
